import React, { useState } from "react";
import { ChevronDown, User, Phone, FileText } from "lucide-react";

const RideDetailsCard = ({ booking = {}, isExpanded, onToggle }) => {
  // Format pickup date
  const pickupDate = booking.pickup_date
    ? booking.pickup_date.includes("-")
      ? new Date(booking.pickup_date).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : booking.pickup_date
    : "—";

  // Format pickup time (extract from UTC timestamp without timezone conversion)
  const pickupTime = booking.pickup_time
    ? booking.pickup_time.substring(11, 16) 
    : "—";

  const pickupDateTime =
    pickupDate && pickupTime
      ? `${pickupDate}, ${pickupTime}`
      : pickupDate || pickupTime || "—";
  pickupDate && pickupTime
    ? `${pickupDate}, ${pickupTime}`
    : pickupDate || pickupTime || "—";

  const pickupLocation = booking.pickup_location || "Unknown";
  const dropoffLocation = booking.dropoff_location || "Unknown";
  const vehicle = booking.vehicle_name || booking.vehicle || "Unknown";
  const luggage = booking.luggage_count ?? "—";
  const passengerName = booking.name || "—";
  const phoneNumber = booking.phone_number || "—";
  const driverInstructions = booking.driver_instructions || "—";

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden transition-all duration-300">
      {/* Collapsed Summary */}
      <button
        onClick={onToggle}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-gray-50 transition-colors"
      >
        <div className="text-left">
          <p className="font-medium text-gray-900">Ride Details</p>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${
            isExpanded ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Expanded Content */}
      {isExpanded && (
        <div className="border-t border-gray-200 px-4 py-4 space-y-3 bg-gray-50">
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
              {/* <User className="w-3 h-3" /> */}
              Passenger Name
            </p>
            <p className="text-sm text-gray-900 mt-1">{passengerName}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
              {/* <Phone className="w-3 h-3" /> */}
              Contact Number
            </p>
            <p className="text-sm text-gray-900 mt-1">{phoneNumber}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">
              Pickup Date/Time
            </p>
            <p className="text-sm text-gray-900 mt-1">{pickupDateTime}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">
              Pickup Location
            </p>
            <p className="text-sm text-gray-900 mt-1">{pickupLocation}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">
              Dropoff Location
            </p>
            <p className="text-sm text-gray-900 mt-1">{dropoffLocation}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">
              Vehicle
            </p>
            <p className="text-sm text-gray-900 mt-1">{vehicle}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">
              Number of Luggage
            </p>
            <p className="text-sm text-gray-900 mt-1">{luggage}</p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase flex items-center gap-1">
              {/* <FileText className="w-3 h-3" /> */}
              Driver Instructions
            </p>
            <p className="text-sm text-gray-900 mt-1 whitespace-pre-wrap">{driverInstructions}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RideDetailsCard;
